module.exports = __webpack_public_path__ + "assets/img/Type E (52).4c5a4e36.jpg";